var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    strokeWidth: 0,
    fill: "currentColor",
    width: "1em",
    height: "1em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8832 20.578L17.3306 16.0253C18.6599 14.3624 19.3019 12.2536 19.1248 10.132C18.9477 8.0105 17.965 6.03731 16.3784 4.6178C14.7918 3.19828 12.7218 2.44021 10.5937 2.49931C8.46561 2.5584 6.44092 3.43017 4.93555 4.93555C3.43017 6.44092 2.5584 8.46561 2.49931 10.5937C2.44021 12.7218 3.19828 14.7918 4.6178 16.3784C6.03731 17.965 8.0105 18.9477 10.132 19.1248C12.2536 19.3019 14.3624 18.6599 16.0253 17.3306L20.578 21.8832C20.7511 22.0563 20.9858 22.1536 21.2306 22.1536C21.4754 22.1536 21.7102 22.0563 21.8832 21.8832C22.0563 21.7102 22.1536 21.4754 22.1536 21.2306C22.1536 20.9858 22.0563 20.7511 21.8832 20.578L21.8832 20.578ZM10.846 17.3075C9.56802 17.3075 8.31875 16.9286 7.25615 16.2186C6.19356 15.5086 5.36536 14.4994 4.87631 13.3187C4.38725 12.138 4.25929 10.8388 4.50861 9.5854C4.75793 8.33199 5.37333 7.18065 6.27699 6.27699C7.18065 5.37332 8.33199 4.75792 9.58541 4.5086C10.8388 4.25928 12.138 4.38724 13.3187 4.8763C14.4994 5.36536 15.5086 6.19355 16.2186 7.25615C16.9286 8.31874 17.3075 9.56801 17.3075 10.846C17.3056 12.5591 16.6242 14.2015 15.4129 15.4129C14.2015 16.6242 12.5591 17.3056 10.846 17.3075Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.5e2d57756b2dd170a7dbb99fa9f4834a.svg";
export { ForwardRef as ReactComponent };